import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["mobileFilterTypes", "itemsCount", "showSort"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FILTER_TYPES } from '../../constants/TopFilterConstants';
import { Set as ImmutableSet } from 'immutable';
// @ts-expect-error Could not find a declaration file for module
import { useSearchParamInput } from '../../hooks/searchParamHooks';
import LanguageNames from 'ui-addon-i18n/constants/LanguageNames';
import { PanelCheckbox } from '../../components/Modals/FullScreenModal/PanelCheckbox';
import { MobileFilterPanel } from '../../components/Modals/FullScreenModal/MobileFilterPanel';
import { PanelSection } from '../../components/Modals/FullScreenModal/PanelSection';
import { getMyPlaylistsUrl } from '../../features/myPlaylists/myPlaylistsRouting';
import useNavigate from '../../hooks/useNavigate';
import { isNoResetOptionFilter, isSearchFilter, isSingleOptionFilter } from '../../features/filters/filtersUtils';
import { useDefaultFilterValue, useFilterOptions } from '../../features/filters/filtersHooks';
import { useCallback, useState } from 'react';
import styled from 'foundations-theming/utils';
import { AccordionTransition } from 'foundations-components/transitional/components/AccordionTransition';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { DownIcon } from 'foundations-assets/icons/components/DownIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RotatingUIIcon = styled.span.withConfig({
  displayName: "MobileTopFilterPanel__RotatingUIIcon",
  componentId: "blcr2q-0"
})(["transition:transform 200ms ease-out;transform:", ";"], ({
  $isOpen
}) => $isOpen ? 'rotate(-180deg)' : 'rotate(0deg)');
const AccordionSection = ({
  name,
  'data-test-id': dataTestId,
  children
}) => {
  const [open, setOpen] = useState(false);
  const handleToggleOpen = useCallback(() => {
    setOpen(b => !b);
  }, []);
  return /*#__PURE__*/_jsxs(View, {
    marginInlineStart: "500",
    children: [/*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      borderBlockEndColor: "border-core-subtle",
      borderBlockEndStyle: "solid",
      borderBlockEndWidth: "100",
      "data-test-id": dataTestId,
      justifyContent: "space-between",
      onClick: handleToggleOpen,
      paddingBlock: "300",
      paddingInlineEnd: "500",
      children: [/*#__PURE__*/_jsx("strong", {
        children: name
      }), /*#__PURE__*/_jsx(RotatingUIIcon, {
        $isOpen: open,
        children: /*#__PURE__*/_jsx(DownIcon, {
          color: "fill-accent-blue-default"
        })
      })]
    }), /*#__PURE__*/_jsx(AccordionTransition, {
      duration: 200,
      open: open,
      children: /*#__PURE__*/_jsx("div", {
        children: children
      })
    })]
  });
};
const filterTypes = Object.values(FILTER_TYPES);
export const FilterGroup = ({
  filterType
}) => {
  const options = useFilterOptions(filterType);
  const [paramValue, changeHandler] = useSearchParamInput(filterType, false);
  const [__, changeHandlerReplace] = useSearchParamInput(filterType, true);
  const value = useDefaultFilterValue(paramValue, filterType);
  const valuesSet = ImmutableSet(value);
  const navigate = useNavigate();
  const onChange = useCallback((item, e) => {
    if (filterType === 'myPlaylistsType') {
      navigate(getMyPlaylistsUrl({
        tab: item
      }));
    } else if (isSingleOptionFilter(filterType)) changeHandlerReplace(e);else changeHandler(e);
  }, [changeHandler, changeHandlerReplace, filterType, navigate]);
  return /*#__PURE__*/_jsxs(AccordionSection, {
    "data-test-id": `filter-type-${filterType}`,
    name: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.topFilters.${filterType}.filterTitle`
    }),
    children: [!isNoResetOptionFilter(filterType) && /*#__PURE__*/_jsx(PanelCheckbox, {
      checked: valuesSet.isEmpty(),
      "data-test-id": `${filterType}-filterReset`,
      onChange: changeHandlerReplace,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `learningCenter.topFilters.${filterType}.filterReset`
      })
    }, "filterReset"), options.map(item => /*#__PURE__*/_jsx(PanelCheckbox, {
      checked: valuesSet.contains(item),
      "data-test-id": `${filterType}-${item}`,
      onChange: e => onChange(item, e),
      value: item,
      children: filterType === 'language' ? LanguageNames[item.toLowerCase()] : /*#__PURE__*/_jsx(FormattedMessage, {
        message: `learningCenter.topFilters.${filterType}.${item}`
      })
    }, item))]
  });
};
const MobileTopFilterPanel = _ref => {
  let {
      mobileFilterTypes,
      itemsCount,
      showSort
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(MobileFilterPanel, Object.assign({
    filterTypes: filterTypes,
    totalFilteredItemsCount: itemsCount
  }, restProps, {
    children: /*#__PURE__*/_jsxs(PanelSection, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.mobileFilters.filterBy"
      }),
      children: [filterTypes && mobileFilterTypes.map(value => !isSearchFilter(value) && /*#__PURE__*/_jsx(FilterGroup, {
        filterType: value
      }, value)), showSort && /*#__PURE__*/_jsx(FilterGroup, {
        filterType: 'sortBy'
      })]
    })
  }));
};
export default MobileTopFilterPanel;